import { ColumnWidths, toWidths } from "./candidate_column_prefs";

export function columnWidths(table: HTMLTableElement): ColumnWidths {
  try {
    return toWidths(JSON.parse(table.dataset.widths || "{}"));
  } catch (_e) {
    return {};
  }
}

function styleFor(table: HTMLTableElement): HTMLStyleElement {
  const wrap = table.parentElement || document.body;
  let style = wrap.querySelector<HTMLStyleElement>(":scope > style[data-col-widths]");
  if (!style) {
    style = document.createElement("style");
    style.dataset.colWidths = "";
    wrap.insertBefore(style, table);
  }
  return style;
}

// Same rules as BotsProspects::PhoneDashboardHelper#phone_column_widths_css: the fixed width, and the
// cells' inline 150px cap on .short-content lifted so the text fills a widened column.
const KEY = /^[a-z_]+$/;

const rulesFor = (key: string, px: number): string => {
  const col = `table.grid.phone-dashboard [data-col="${key}"]`;
  return (
    `${col}{width:${px}px !important;min-width:${px}px !important;max-width:${px}px !important}\n` +
    `${col} .short-content{max-width:none !important;min-width:0}`
  );
};

export function setColumnWidths(table: HTMLTableElement, widths: ColumnWidths): void {
  const clean = toWidths(widths);
  table.dataset.widths = JSON.stringify(clean);
  styleFor(table).textContent = Object.entries(clean)
    .filter(([key]) => KEY.test(key))
    .map(([key, px]) => rulesFor(key, px))
    .join("\n");
}
